var exports = {
  "r": "CardBaseWithSash__jsybUa",
};

module.exports = exports;
